import React from "react";
import Atanu from "../Images/Atanu_pic2.jpg"
const Details = () => {
  return (
    <div className="container mb-4">
      <div className="row mt-5 mb-4">
        <div className="col-md-7">
          <h3>Atanu K Metya</h3>
          <div className="text-uppercase cbe profile">
            Working as Assistant Professor at IIT Patna (2020 - present)
          </div>
          <i className="bi bi-telephone-fill"></i>
          &nbsp;+91 6115 233 831&nbsp;
          <i className="bi bi-envelope-fill"></i>
          &nbsp;atanu.metya@iitp.ac.in
          <br />
          <a
            href="https://scholar.google.com/citations?user=xr_M--QAAAAJ&amp;hl=en&amp;oi=ao"
            target={"_blank"}
          >
            <img
              className="links"
              src="https://upload.wikimedia.org/wikipedia/commons/2/28/Google_Scholar_logo.png?20190206225436"
              alt=""
            />
          </a>
          &nbsp;&nbsp;&nbsp;
          <a
            href="https://www.linkedin.com/in/atanu-metya-64235b19/"
            target={"_blank"}
          >
            <img
              className="links"
              src="https://www.edigitalagency.com.au/wp-content/uploads/Linkedin-logo-png.png"
              alt=""
            />
          </a>
          &nbsp;&nbsp;&nbsp;
          <a href="https://orcid.org/0000-0002-9778-8126" target={"_blank"}>
            <img
              className="links"
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/14/ORCID_logo.svg/2560px-ORCID_logo.svg.png"
              alt=""
            />
          </a>
        </div>
        <div className="col-md-5 text-center">
          <p className="card-text mb-auto">
            <img className="atanu-img" src={Atanu} alt="" />
          </p>
        </div>
      </div>
      <div className="mt-4">
        <h4>Education</h4>
        <hr className="helper1" />
        <div className="row">
          <div className="col-sm-4 text-center">
            <b>Program</b>
          </div>
          <div className="col-sm-6 text-center">
            <b>Institution</b>
          </div>
          <div className="col-sm-2 text-center">
            <b>Year</b>
          </div>
        </div>
        <hr className="helper2" />
        <div className="row">
          <div className="col-sm-4 text-center mb-1">
            <b>Ph.D.</b> <i>&nbsp;(Chemical Engineering)</i>
          </div>
          <div className="col-sm-6 text-center mb-1">
            Indian Institute of Technology Kanpur
          </div>
          <div className="col-sm-2 text-center mb-1">2018</div>
          <div className="col-sm-4 text-center mb-1">
            <b>M.Tech.</b> <i>&nbsp;(Chemical Engineering)</i>
          </div>
          <div className="col-sm-6 text-center mb-1">
            Indian Institute of Technology Kanpur
          </div>
          <div className="col-sm-2 text-center mb-1">2011</div>
          <div className="col-sm-4 text-center mb-1">
            <b>B.Tech.</b> <i>&nbsp;(Chemical Engineering)</i>
          </div>
          <div className="col-sm-6 text-center mb-1">
            University College of Science & Technology, University of Calcutta
          </div>
          <div className="col-sm-2 text-center mb-1">2009</div>
          <div className="col-sm-4 text-center mb-1">
            <b>B.Sc.</b> <i>&nbsp;(Chemistry, (Hons.))</i>
          </div>
          <div className="col-sm-6 text-center mb-1">
            University of Calcutta
          </div>
          <div className="col-sm-2 text-center mb-1">2006</div>
        </div>
      </div>
      <div className="mt-4">
        <h4>Work Experience</h4>
        <hr className="helper1" />
        <div className="row">
          <div className="col-sm-6">
            <b>Indian Institute of Technology Patna, India</b>
            <div className="cbe profile">
              Assistant Professor in department of Chemical and Biochemical
              Engineering
            </div>
          </div>
          <div className="col-sm-6">
            <div className="text-uppercase cbe d-flex justify-content-end profile">
              July, 2020-present
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-sm-6">
            <b>University of Utah, USA</b>
            <div className="cbe profile">
              India Postdoctoral Research Fellow in department of Chemistry
            </div>
          </div>
          <div className="col-sm-6">
            <div className="text-uppercase cbe d-flex justify-content-end profile">
              March, 2019 – June, 2020
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-sm-6">
            <b>Indian Institute of Technology Kanpur, India</b>
            <div className="cbe profile">
              Senior Research Fellow in department of Chemical Engineering
            </div>
          </div>
          <div className="col-sm-6">
            <div className="text-uppercase cbe d-flex justify-content-end profile">
              October, 2017 – February, 2019
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-sm-6">
            <b>Indian Institute of Technology Kanpur, India</b>
            <div className="cbe profile">
              Project Engineer in department of Chemical Engineering
            </div>
          </div>
          <div className="col-sm-6">
            <div className="text-uppercase cbe d-flex justify-content-end profile">
              August, 2011 – June, 2012
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4">
        <h4>Courses</h4>
        <hr className="helper1" />
        <div>
          <b>CB206</b>: Chemical Engineering Thermodynamics
          <br />
          <b>CB208</b>: Process Equipment Design - I
          <br />
          <b>CB305</b>: Chemical Process Technology
          <br />
          <b>CB307 </b>: Process Equipment Design - II
          <br />
          <b>CB407 </b>: Process Plant Design & Economics
          <br />
          <b>CB424 </b>: Numerical Methods in Chemical Engineering
          <br />
        </div>
      </div>
      <div className="mt-4">
        <h4>Research Area</h4>
        <hr className="helper1" />
        <div>
          Thermodynamics and statistical mechanics; Molecular Simulations: phase
          equilibria and nucleation; design of anti-icing surfaces, wetting
          phenomena; Structure, dynamics, and interfacial properties of
          solutions in bulk and confined systems; and force filed development
          using density functional theory.
        </div>
      </div>
      <div className="mt-4">
        <h4>Awards and Honours</h4>
        <hr className="helper1" />
        <li>
          International Travel Support, Government of India: 2013 and 2017
        </li>
        <li>MHRD Fellowship for M.Tech and Ph.D</li>
      </div>
    </div>
  );
};

export default Details;
